import { createReducer } from 'redux-create-reducer'
import type { NativeTag } from 'types/track'
import {
  NATIVE_TAGS_EDIT,
  PRELOAD_DATA_ON_LOGIN,
} from '@disco/constants/ActionTypes'
export type NativeTagsState = { [key in NativeTag['id']]?: NativeTag }
const initialState: NativeTagsState = {}
export const nativeTagsReducer = createReducer<NativeTagsState, any>(
  initialState,
  {
    [PRELOAD_DATA_ON_LOGIN](_state, action) {
      return action.entities.nativeTags ?? initialState
    },

    [NATIVE_TAGS_EDIT](state, action) {
      const updatedState = { ...state }

      if (action.tag) {
        updatedState[action.tag.id] = {
          ...updatedState[action.tag.id],
          ...action.tag,
        }
      } else if (action.id) {
        delete updatedState[action.id]
      }

      return updatedState
    },
  },
)
